import { Component, OnInit, Inject } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import {
  caseListTemplate,
  CaseListComponent,
  Filter,
  ResourceDefinition,
  BreadcrumbService,
  FlashMessageService,
  ResourceService,
  CaseConfig,
  Yield,
  InputType,
  AuthService,
  FilterService
} from '@case-app/angular-library'

import { customerDefinition } from '../customer.definition'
import { customerYields } from '../customer.yields'

@Component({ template: caseListTemplate })
export class CustomerListComponent extends CaseListComponent implements OnInit {
  definition: ResourceDefinition = customerDefinition
  yields: Yield[] = customerYields

  filters: Filter[] = [
    {
      label: 'Rechercher un client',
      placeholder: 'Chercher un client par nom...',
      inputType: InputType.MultiSearch,
      className: 'is-12',
      searchResources: [customerDefinition],
      properties: {
        customerIds: 'customerIds'
      }
    }
  ]

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    resourceService: ResourceService,
    breadcrumbService: BreadcrumbService,
    flashMessageService: FlashMessageService,
    filterService: FilterService,
    authService: AuthService,
    @Inject('CASE_CONFIG_TOKEN') config: CaseConfig
  ) {
    super(
      router,
      activatedRoute,
      breadcrumbService,
      resourceService,
      flashMessageService,
      authService,
      filterService,
      config
    )
  }

  ngOnInit() {
    this.initListView()
  }
}
